import { type ReactNode } from 'react';

interface Tab {
  id: string;
  label: string;
  icon?: ReactNode;
  count?: number;
}

interface TabsProps {
  tabs: Tab[];
  active: string;
  onChange: (id: string) => void;
}

export function Tabs({ tabs, active, onChange }: TabsProps) {
  return (
    <div className="flex gap-1 rounded-xl bg-surface-800/50 p-1 border border-surface-700/50">
      {tabs.map((tab) => (
        <button
          key={tab.id}
          onClick={() => onChange(tab.id)}
          className={`flex items-center gap-2 rounded-lg px-4 py-2 text-sm font-medium transition-all
            ${active === tab.id
              ? 'bg-surface-700 text-surface-100 shadow-sm'
              : 'text-surface-400 hover:text-surface-200 hover:bg-surface-700/50'
            }`}
        >
          {tab.icon}
          {tab.label}
          {tab.count !== undefined && (
            <span className={`ml-1 rounded-full px-2 py-0.5 text-xs
              ${active === tab.id
                ? 'bg-nexus-600/20 text-nexus-400'
                : 'bg-surface-600/50 text-surface-500'
              }`}>
              {tab.count}
            </span>
          )}
        </button>
      ))}
    </div>
  );
}

export type { Tab };
